import HubspotForm from "./_components/hubspot-form";

export default HubspotForm;
